import { routes } from "@/common/utils/routes";
import { UserListWidgetAlive } from "@/components/widgets/UserListWidgetAlive";
import { useTrendingUsers } from "@/common/hooks/useTrendingUsers";
import { FeedModuleTypeEnum } from "@/common/services/types";
import { FeedModuleContainer } from "../FeedModules/FeedModuleContainer";

interface SuggestedCreatorsProps {
  moduleId: string;
  moduleType: FeedModuleTypeEnum;
}

export const SuggestedCreators = ({ moduleId, moduleType }: SuggestedCreatorsProps) => {
  const { creators, isLoading } = useTrendingUsers();

  if (isLoading || !creators.length) {
    return null;
  }

  return (
    <FeedModuleContainer moduleId={moduleId} moduleType={moduleType}>
      <UserListWidgetAlive
        className="suggestedCreators"
        title="Suggested Creators"
        link={routes.creators()}
        items={creators}
      />
    </FeedModuleContainer>
  );
};
